var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    width: 512,
    height: 512,
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#004c3f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m63 3v-2h-31c-0.553 0-1 0.447-1 1v8c0 0.553 0.447 1 1 1h1v50h-32v2h62v-2h-12v-5h12v-2h-20v-2h20v-2h-21c-0.553 0-1 0.447-1 1v4c0 0.553 0.447 1 1 1h3v5h-6v-50h24v-2h-30v-6zm-16 53h2v5h-2zm-10-45v50h-2v-50z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m21 32c0-2.118-.501-4.238-1.447-6.131l-.658-1.316c-.34-.678-1.449-.678-1.789 0l-.658 1.316c-.947 1.893-1.448 4.013-1.448 6.131 0 .241.029.481.042.722-.646-.483-1.383-.837-2.172-1.034l-2.628-.657c-.338-.087-.701.015-.949.263s-.349.608-.263.949l.657 2.629c.269 1.073.823 2.055 1.605 2.836.781.782 1.763 1.337 2.836 1.605h.001l.672.168-1.25.625.895 1.789 2.554-1.277v2.382h-7c-.553 0-1 .447-1 1v4c0 .553.447 1 1 1h1.095l.91 9.1c.051.51.481.9.995.9h10c.514 0 .944-.39.995-.9l.91-9.1h1.095c.553 0 1-.447 1-1v-4c0-.553-.447-1-1-1h-7v-2.382l2.553 1.276.895-1.789-1.25-.625.672-.168h.001c1.073-.269 2.055-.823 2.836-1.605.782-.781 1.337-1.763 1.605-2.837l.657-2.628c.086-.341-.015-.701-.263-.949s-.609-.35-.949-.263l-2.629.657c-.788.197-1.525.551-2.171 1.034.014-.24.043-.48.043-.721zm1.095 25h-8.189l-.8-8h9.79zm2.905-10h-14v-2h14zm-7-19.734c.655 1.485 1 3.11 1 4.734s-.345 3.249-1 4.734c-.655-1.485-1-3.11-1-4.734s.345-3.249 1-4.734zm-5.293 9.027c-.525-.525-.898-1.186-1.08-1.907l-.252-1.011 1.01.252c.723.182 1.383.555 1.908 1.08s.898 1.186 1.08 1.907l.252 1.011-1.01-.252c-.722-.182-1.383-.555-1.908-1.08zm10.907-2.666 1.011-.252-.252 1.01c-.182.723-.555 1.383-1.08 1.908s-1.186.898-1.908 1.08l-1.01.252.252-1.01c.182-.723.555-1.383 1.08-1.908s1.186-.898 1.907-1.08z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m5 15h13c2.757 0 5-2.243 5-5s-2.243-5-5-5c-.438 0-.877.061-1.303.18-.766-2.455-3.023-4.18-5.697-4.18-3.309 0-6 2.691-6 6-2.206 0-4 1.794-4 4s1.794 4 4 4zm0-6c.27 0 .533.054.783.16.352.147.756.085 1.043-.163.288-.248.411-.639.317-1.007-.098-.377-.143-.692-.143-.99 0-2.206 1.794-4 4-4 2.081 0 3.784 1.574 3.961 3.662.028.345.233.648.54.806.308.158.675.145.97-.032.483-.29.997-.436 1.529-.436 1.654 0 3 1.346 3 3s-1.346 3-3 3h-13c-1.103 0-2-.897-2-2s.897-2 2-2z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrace);
export default __webpack_public_path__ + "static/media/terrace.93e65d2088da1029caa8b8f8e73addaf.svg";
export { ForwardRef as ReactComponent };